import React, {useEffect, useMemo} from "react";
import {Box} from "@mui/system";
import {useDispatch, useSelector} from 'react-redux'
import StepIndicator from "../../CompanyOnboarding/Utils/StepIndicator";
import {
    ShopifyProvider,
    GorgiasProvider,
    ZendeskProvider,
    TikTokProvider,
    TikTokAdsProvider,
    TikTokShopProvider,
    SalesforceProvider,
    CustomerIoProvider,
    DixaProvider,
    FreshdeskProvider,
    FrontappProvider,
    YoutubeProvider,
    TrustpilotProvider,
    ReamazeProvider,
    KustomerProvider,
    HelpScoutProvider,
    GladlyProvider,
    FacebookProvider,
    InstagramProvider
} from "../Providers";
import CurvedFooter from "../../CompanyOnboarding/Utils/CurvedFooter";
import {msgSourceActions} from "../../../../../_actions";
import {getFilteredMsgSources} from "../Utilities/channelsUtils"
import {Loading} from "../../../../common";
import ReactGA from "react-ga";
import {GOOGLE_ANALYTICS_TRACKING_ID} from "_constants";
import importedStyles from "../styles/Channels.module.css"

export default function ConnectChannels(){
    const dispatch = useDispatch()
    const _msgSourcesFromState = useSelector((state) => state.msgSources.msgSources)
    const userLoggedIn = useSelector((state) => state.auth.loggedIn)
    const msgSourceLoading = useSelector((state) => state.msgSources.loading)
    const loading = (!userLoggedIn) || msgSourceLoading

    const msgSources = useMemo(() => getFilteredMsgSources({ msgSources: _msgSourcesFromState ?? [], returnCredentialsExpired: false }), [_msgSourcesFromState])

    useEffect(() => {
        const currentUser = JSON.parse(localStorage.user);
        const organizationId = currentUser._embedded.organization.id;
        dispatch(msgSourceActions.getAll({ organizationId: organizationId }))
    }, [])

    useEffect(() => {
        ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID)
        ReactGA.pageview(window.location.pathname)
    }, [])

    if(loading) return <Loading height={400} />

    return(
        <Box sx={styles.root}>
            <Box>
                <Box sx={styles.container}>
                    {(msgSources.length === 0)  &&
                        <Box mb={2}>
                            <StepIndicator current={2} total={2} />
                        </Box>
                    }

                    <Box>
                        <Box component={'h1'} sx={styles.headingText}>
                            Connect channels
                        </Box>
                        <Box component={'p'} sx={styles.helperText}>
                            Connect to channels supported by Remarkable AI. Don’t see what you’re looking for?
                            <br/>
                            Contact <a href='mailto:support@beremarkable.ai' target='_blank' rel='noopener' className={importedStyles.supportLink}>support@beremarkable.ai</a> for help.
                        </Box>
                    </Box>

                    <Box component={'ul'} sx={styles.cardUl}>
                        <ShopifyProvider/>
                        <GorgiasProvider/>
                        <ZendeskProvider/>
                        <DixaProvider/>
                        <TikTokProvider/>
                        <TikTokAdsProvider/>
                        <TikTokShopProvider/>
                        <FacebookProvider/>
                        <InstagramProvider/>
                        <YoutubeProvider/>
                        <SalesforceProvider/>
                        <CustomerIoProvider/>
                        <FreshdeskProvider/>
                        <FrontappProvider/>
                        <TrustpilotProvider/>
                        <ReamazeProvider/>
                        <KustomerProvider/>
                        <HelpScoutProvider/>
                        <GladlyProvider/>
                    </Box>
                </Box>

                <Box sx={styles.footerContainer}>
                    <CurvedFooter />
                </Box>
            </Box>
        </Box>
    )
}

const styles = {
    root: {
        background: "#edede4",
    },
    container: {
        px: { xs: 2, sm: 6 },
        pt: 15.5,
        pb: 10,
        maxWidth: 1100,
    },
    headingText: {
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: '50px',
        color: '#0C2728',
        lineHeight: 0.9,
        mt: 0
    },
    helperText: {
        fontFamily: 'FustatRegular',
        fontSize: '16px',
        color: '#0C2728',
        mt: 2.5,
        lineHeight: 1.2,
    },
    link: {
        color: 'rgba(48, 46, 42, 1)',
        textDecoration: 'underline',
        textUnderlineOffset: '2px',

    },
    cardUl: {
        mt: { xs: 4, sm: 6 },
        listStyle: 'none',
        mb: 0,
        p: 0,
        px: {xs: 0, sm: 6},
        py: 2,
        backgroundColor: '#FFFFFF',
        borderRadius: 5,
        boxShadow: 3,
    },
    footerContainer: {
        width: '100%',
        height: {xs: '270px', md: '220px'},
    }
}